import { render, staticRenderFns } from "./tabSearch.vue?vue&type=template&id=20ce479f&"
import script from "./tabSearch.vue?vue&type=script&lang=js&"
export * from "./tabSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports